<template>
  <el-pagination
    background
    layout="prev, pager, next"
    :total="total"
    :current-page="page"
    :page-size="limit"
    @current-change="handlePageChange"
    @size-change="handleSizeChange"
  />
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    total: { type: Number, required: true },
    page: { type: Number, default: 1 },
    limit: { type: Number, default: 10 }
  },
  methods: {
    handlePageChange(page) {
      this.$emit('update:page', page)
      this.$emit('page-change', page)
    },
    handleSizeChange(limit) {
      this.$emit('update:limit', limit)
      // 你也可以 emit page-change 或者自定义事件
    }
  }
}
</script>